module.exports = __webpack_public_path__ + "static/img/bg-bule.5daf1d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg-bule.png
// module id = /brB
// module chunks = 1